import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import { useHistory } from 'react-router';
//import { get } from 'lodash';
import { DropDown, Menu, MenuItem, Button } from 'src/components/Antd';
import { EnumStatus } from 'src/types/common/discount';
import css from './css.module.less';
///import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
//import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import { UsergroupAddOutlined, ContainerOutlined } from '@ant-design/icons';
//import { Icon } from '@/src/tools/icon';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TopRight = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    hasModified,
    onSubmit,
    status,
    isNew,
    onDuplicate,
    onArchive,
    onPublish,
    onRestore,
    onDraft,
    disabled,
    canChangeStatus,
    canEdit,
  } = props;
  const actionGenerator = () => {
    const overlay = (
      <Menu className={css.menu}>
        <MenuItem className={css.menuItem} onClick={onDuplicate}>
          {getI18n('general.duplicate')}
        </MenuItem>
        <MenuItem className={css.menuItemArchive} onClick={onArchive}>
          {getI18n('general.archive')}
        </MenuItem>
      </Menu>
    );

    if (status !== EnumStatus.Archived) {
      return (
        <div className={css.actionBtnContainer}>
          <DropDown.Button
            className={css.actionBtn}
            overlay={overlay}
            placement='bottomRight'
            trigger={['click']}>
            {getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            )}
          </DropDown.Button>
        </div>
      );
    }
  };

  const greenBtn = () => {
    if (disabled && status !== EnumStatus.Archived) {
      return null;
    }
    if (status === EnumStatus.Draft) {
      return (
        <Button
          type='primary'
          className={css.greenBtn}
          onClick={onPublish}
          ghost>
          {getI18n('general.issue')}
        </Button>
      );
    }
    if (
      status === EnumStatus.Issued ||
      status === EnumStatus.Scheduled ||
      status === EnumStatus.Expired ||
      status === EnumStatus.Active
    ) {
      return (
        <Button type='primary' className={css.greenBtn} onClick={onDraft} ghost>
          {getI18n('general.switchToDraft')}
        </Button>
      );
    }
    if (status === EnumStatus.Archived) {
      return (
        <Button
          className={css.greenBtn}
          type='primary'
          onClick={onRestore}
          ghost>
          {getI18n('general.restore')}
        </Button>
      );
    }
  };
  const rightBtnGenerator = () => {
    if (isNew) {
      return null;
    }
    if (disabled && status !== EnumStatus.Archived) {
      return (
        <React.Fragment>
          {canChangeStatus && (
            <Button
              icon={<ContainerOutlined />}
              onClick={onArchive}
              className={css.archive}>
              {getI18n('general.archive')}
            </Button>
          )}
          {canEdit && (
            <Button
              icon={<UsergroupAddOutlined />}
              onClick={onDuplicate}
              className={css.duplicate}>
              {getI18n('general.duplicate')}
            </Button>
          )}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {actionGenerator()}
        {greenBtn()}
      </React.Fragment>
    );
  };

  //const s = useParams();
  //const salesChannelUuid = get(s, 'uuid');

  const h = useHistory();
  const onD = () => {
    h.push(`/storeVoucherList`);
  };
  return (
    <_TopRight
      {...(disabled
        ? {}
        : {
            onDiscard: onD,
            onSubmit,
          })}
      // onDiscard={onD}
      onSaveDisable={!hasModified}
      // onSubmit={onSubmit}
      extendButton={rightBtnGenerator()}
    />
  );
};
export default TopRight;
